// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3er_8","title":"styles_title__2Mr-E","subTitle":"styles_subTitle__1naQw"};